import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ documentId = '', ...params }) => {
  return await dponetAPI.get(`/documents/${documentId}`, { params })
}

const getCategories = async (params) => {
  return await dponetAPI.get('/document_categories', { params })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/documents', { document: data })
}

const put = async ({ documentId = '', ...data }) => {
  return await dponetAPI.put(`/documents/${documentId}`, data)
}

const destroy = async ({ documentId = '', ...data }) => {
  return await dponetAPI.delete(`/documents/${documentId}`, data)
}

export default {
  get,
  getCategories,
  create,
  put,
  destroy,
}
